import { render, staticRenderFns } from "./adapay.vue?vue&type=template&id=79680af8"
import script from "./adapay.vue?vue&type=script&lang=js"
export * from "./adapay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports